<div class="rvp">

    <!-- Top floating bar -->
    <div class="rvp-top" *ngIf="!validUntil">
        <div class="glass top-pill">
            <button class="icon-btn back" (click)="navigateBack()" title="بازگشت">
                <i class="fa fa-arrow-right"></i>
            </button>

            <div class="top-car" *ngIf="carName">
                <span>
                    {{ carName }}
                    <small *ngIf="carPlate">{{ carPlate }}</small>
                </span>
            </div>

            <button class="icon-btn ghost" (click)="openGuide()" title="راهنما">
                <i class="fa fa-question"></i>
            </button>
        </div>
    </div>

    <!-- Live stats and filters -->
    <div class="rvp-side" *ngIf="!validUntil">
        <div class="glass side-pill" *ngIf="speed || speed == '0' || lastTime || (!isCarListMode && (travelledDistance || travelledDistance == '0') && tempAccessToken == 0)">
            <div class="live-inline">
                <span class="top-stat speed" *ngIf="speed || speed == '0'" data-tip="سرعت لحظه‌ای">
                    <i class="fa fa-tachometer"></i>
                    <b class="dirI">{{ speed }}<small>km/h</small></b>
                </span>

                <span class="top-stat dist" *ngIf="!isCarListMode && (travelledDistance || travelledDistance == '0') && tempAccessToken == 0" data-tip="پیمایش">
                    <i class="fa fa-road"></i>
                    <b class="dirI">
                        <ng-container *ngIf="unitId == 'trackAll'; else notTrackAll">
                            <span *ngIf="lastCallTime">{{ lastCallTime.split(' ')[1] }}</span>
                        </ng-container>
                        <ng-template #notTrackAll>{{ travelledDistance | number }}<small>km</small></ng-template>
                    </b>
                </span>

                <span class="top-stat time" *ngIf="lastTime" data-tip="زمان آخرین موقعیت">
                    <i class="fa fa-clock-o"></i>
                    <b class="dirI">{{ lastTime }}</b>
                </span>
            </div>
        </div>

        <div class="glass side-pill" *ngIf="!carPlate && !isCarListMode && showFilters">
            <label class="filter-item">
                <i class="fa fa-car"></i>
                <select class="glass-select text-center" id="groupCar" (change)="loadCars()">
                    <option value="-1"> نوع خودرو </option>
                    <option *ngFor="let item of carTypes" value="{{item.tiMobileType}}">{{item.strComment}}</option>
                </select>
            </label>

            <div class="dock-sep"></div>

            <label class="filter-item">
                <i class="fa fa-map-marker"></i>
                <select class="glass-select text-center" id="domain" (change)="loadCars()">
                    <option value="-1"> حوزه خدمت </option>
                    <option *ngFor="let item of serviceAreas" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
                </select>
            </label>
        </div>
    </div>

    <!-- Map -->
    <div class="rvp-map" [ngStyle]="{ 'display': isDotOneMap ? 'block' : 'none' }">
        <div id="test" class="w-100 h-100">
            <div id="popup"></div>

            <div class="position-absolute" data-bs-html="true" id="map_tooltips">
            </div>

            <div class="position-absolute" data-bs-html="true" id="map_tooltip">
            </div>
        </div>
    </div>

    <!-- Camera -->
    <div class="cam-float" *ngIf="hasDashCam">
        <div class="glass-dark cam-card">
            <ng-container *ngIf="!cameras[0]?.strUnitId">
                <img src="../../../assets/Img/video-thumb.png" alt="دوربین یک">
            </ng-container>

            <ng-container *ngIf="cameras[0]?.strUnitId">
                <stream-loader [obj_Camera]="cameras[0]"
                    [isHideInfo]="true"
                    [tripId]="tripId"
                    [tiChannel]="channelId"
                    [ScreenShot]="isScreenshot"
                    [expiresAt]="validUntil"
                    (updateChecked)="updateCamera($event)"
                    (hideComponent)="removeCamera($event)">
                </stream-loader>
            </ng-container>
        </div>
    </div>

    <!-- Tool rail -->
    <div class="glass rvp-rail" *ngIf="!validUntil">
        <button class="rail-btn" (click)="toggleBaseMap()" data-tip="تغییر نوع نقشه">
            <img src="../../../assets/Img/layer-icon.png" alt="لایه">
        </button>
        <div class="rail-sep"></div>
        <button class="rail-btn accent" (click)="reload()" data-tip="بارگذاری مجدد">
            <i class="fa fa-refresh"></i>
        </button>
    </div>

</div>
